const ms = require('ms')

const seconds = value => ms(value) ? ms(value) / 1000 : undefined

const millis = value => ms(value)

const convertHHmmToMs = (time) => {
  const tArr = time.split(':')
  const sign = time.charAt(0)
  const tH = tArr[0] * millis('1h')
  const tM = tArr[1] * millis('1m')
  return sign === '-' ? tH - tM : tH + tM
}

module.exports = {
  seconds,
  millis,
  convertHHmmToMs
}
